import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { browserVersion, isMobileSafari, isSafari } from "react-device-detect";
import {
  PlayLiveWrapper,
  PlayLiveLeftWrapper,
  PlayLiveRightWrapper,
  PlayLiveExtend,
  PlayLiveH2,
  PlayLiveDescription,
  PlayLivePUBImg,
  PlayLivePUBImgSafari,
  PlayLiveCACImg,
  PlayLiveHYCImg,
} from "../styledComponents/StyledIndex";
import { StyledButton } from "../styledComponents/CommonStyledComponents";

const PlayLive = ({ pages, skin }) => {
  const { t } = useTranslation("");
  const [forcePng, setForcePng] = useState(false);

  useEffect(() => {
    if ((isMobileSafari || isSafari) && parseInt(browserVersion) < 14)
      setForcePng(true);
  }, []);

  return (
    <>
      <PlayLiveWrapper>
        {skin === "pub" &&
          (forcePng ? <PlayLivePUBImgSafari /> : <PlayLivePUBImg />)}
        {(skin === "cac" || skin === "hyc") && (
          <PlayLiveLeftWrapper>
            {skin === "cac" && <PlayLiveCACImg />}
            {skin === "hyc" && <PlayLiveHYCImg />}
          </PlayLiveLeftWrapper>
        )}
        <PlayLiveRightWrapper>
          <PlayLiveExtend>
            <PlayLiveH2>{t("label_play_live_header")}</PlayLiveH2>
            <PlayLiveDescription>
              {t("label_play_live_par")}
            </PlayLiveDescription>
            <StyledButton
              btn
              pub={skin === "pub"}
              onClick={() => (window.location = pages["live-casino"])}
            >
              {t("label_play_live")}
            </StyledButton>
          </PlayLiveExtend>
        </PlayLiveRightWrapper>
      </PlayLiveWrapper>
    </>
  );
};

export default PlayLive;
